module.exports = __webpack_public_path__ + "static/img/RU.0fb71192.svg";